import { useCallback, useRef, useState } from "react";

import { useGlobalEvent } from "./useGlobalEvent";

export const useEventTriggeredTimeUpdate = (event: string, maxCalls: number = 0) => {
	const called = useRef<number>(0);
	const [time, setTime] = useState<number>(0);

	const updateTime = useCallback(() => {
		called.current++;
		if (maxCalls > 0 && called.current > maxCalls) return;
		setTime(called.current);
	}, [maxCalls]);

	useGlobalEvent(event, updateTime);

	return time;
};
